import { BaseDocVerifierManager } from '../../../core/managers/doc-verifier-manager.base';
import type { ModalReturnType, PasswordModalProps, PasswordParam } from '@tencent/docs-crypto-kit';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export class PcDocVerifierManager extends BaseDocVerifierManager {
    protected async showPasswordModal(props: PasswordModalProps): Promise<ModalReturnType> {
        const { showPasswordModal } = await this.getCryptoKit();
        return showPasswordModal(props);
    }

    protected async validateDocumentPassword(param: PasswordParam): Promise<ModalReturnType> {
        const { validateDocumentPassword } = await this.getCryptoKit();
        return validateDocumentPassword(param);
    }

    protected getOpenVerifierConfig(): PasswordModalProps {
        return {
            onCancel: () => {
                // 关闭桌面端标签
                this.mqq.invoke('docx', 'closeTab');
            },
        };
    }

    protected getModifyVerifierConfig(): PasswordParam {
        return {
            onReadOnlyClick: () => {
                this.showUserReadOnly();
            },
            onCancel: () => {
                this.showUserReadOnly();
            },
            onSuccess: () => {
                this.switchDocReadOnly(false);
            },
        };
    }

    private showUserReadOnly(): void {
        // 标题加入只读
        eventBus.emit(EventKeys.LOCAL_PASSWORD_READONLY);
    }
}
